import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class SimpleAccordion extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get header() {
    return get(this, '_header.value', '');
  }

  get simpleAccordionItems() {
    return get(this, '_simple_accordion_items', []);
  }

  get htmlModifiers() {
    return get(this, '_html_modifiers', []);
  }
}



// WEBPACK FOOTER //
// ./src/models/SimpleAccordion.model.js